import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../enums';
import { IConfig } from '../interfaces/config';
import { IConfigFormat } from '../interfaces/config.format';
import { isNullOrUndefined } from '../shared/common-utils';


@Injectable({
  providedIn: 'root'
})
export class InitService {
  private config: IConfig = {};
  count  = 0
  constructor(
    private http: HttpClient,
  ) { }

  getConfig(type: Config) {
  return this.deepClone(this.config[type as keyof IConfig]);
}


  loadConfig(args: IConfigFormat) {
    return new Promise((resolve, reject) => {
      if (!isNullOrUndefined(args.path) && !isNullOrUndefined(args.configType)) {
        this.http.get(args.path).subscribe({
          next: (res: any) => {
            this.config[args.configType as keyof IConfig] = res;
            resolve(res);
          },
          error: (err) => {
            reject(new Error(err));
          }
        });
      } else {
        throw new Error('Could not load Configuration');
      }
    });
  }

  isEmptyField(value: any) {
    if (isNullOrUndefined(value) || value === '') {
      return true;
    }
    return false;
  }

  deepClone(object: any): any {
    if (this.isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj = new object.constructor();
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];
      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }  
}
